<template>
  <div class="flex items-center justify-center w-full" v-if="loader">
    <t-loader-skeleton w="60px" h="64px" :skeletons="5" direction="row" gap="0px" justifyContent="space-between" class="w-full" />
  </div>
  <div class="flex items-center justify-between" v-else>
    <div
      :style="{color: achievements.includes(achievement) ? themeColorHEX : `rgba(166, 166, 166, ${theme === 'light' ? '1' : '0.3'})`}"
      class="w-16 h-16 cursor-pointer achievement-icon"
      v-for="(achievement, idx) in userAchievementsAll"
      :key="`achievement_${achievement}_ ${idx}`"
      v-html="iconsContent[achievement]"
      @click="$refs.achievementCurtain.tab(`achievements/${achievement}`)"
    />
    <t-curtain ref="achievementCurtain">
      <t-curtain-tab
        v-for="(achievement, idx) in userAchievementsAll"
        group="achievements"
        :name="achievement"
        :key="`achievement_${achievement}_ ${idx}_curtain`"
        :fullscreen="false"
        :historyMode="false"
        :hasClose="true"
      >
        <div class="flex flex-col items-center w-full gap-4">
          <div v-html="iconsContent[achievement]" :style="{color: themeColorHEX}" class="w-[128px] h-[128px] achievement-icon" />
          <t-text color="black" class="font-semibold" size="xl">{{ iconsNames[achievement] }}</t-text>
          <t-text color="black" class="xs:leading-[26px] text-center">{{ iconsDescriptions[achievement] }}</t-text>
        </div>
      </t-curtain-tab>
    </t-curtain>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 't-user-achievements',
    props: {
      achievements: {
        type: Array,
        required: true
      }
    },
    data() {
      const legend = this.$t('components.badges.legend')
      const legend_description = this.$t('components.badges.legend_description')
      const push = this.$t('components.badges.push')
      const push_description = this.$t('components.badges.push_description')
      const leader = this.$t('components.badges.leader')
      const leader_description = this.$t('components.badges.leader_description')
      const meetmaster = this.$t('components.badges.meetmaster')
      const meetmaster_description = this.$t('components.badges.meetmaster_description')
      const connector = this.$t('components.badges.connector')
      const connector_description = this.$t('components.badges.connector_description')
      return {
        loader: true,
        iconsContent: {},
        iconsNames: {
          legend,
          push,
          leader,
          meetmaster,
          connector
        },
        iconsDescriptions: {
          legend: legend_description,
          push: push_description,
          leader: leader_description,
          meetmaster: meetmaster_description,
          connector: connector_description
        }
      }
    },
    computed: {
      ...mapGetters('user', ['userAchievementsAll']),
      ...mapGetters(['themeColorHEX', 'theme'])
    },
    async mounted() {
      this.userAchievementsAll.forEach(async achievement => {
        const icon = await fetch(require(`@/assets/static/img/achievements/${achievement}.svg`))
        const icon_content = await icon.text()
        this.iconsContent[achievement] = icon_content
        if (Object.keys(this.iconsContent).length === this.userAchievementsAll.length) {
          setTimeout(() => {
            this.loader = false
          }, 500)
        }
      })
    }
  }
</script>
